/*
 * @Description: 路由
 * @Date: 2026-03-30 16:06:33
 */
export const route = [
  {
    path: '/park-mgmt-list',
    name: 'park-mgmt-list',
    meta: {
      title: '园区管理'
    },
    component: () => import('../views/park-mgmt-list/park-mgmt-list.vue')
  }
];
